






























































































































import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Getter } from 'vuex-class';
import { clone } from 'lodash';
import arrayMove from 'array-move';
import { VuetableSortOrder, VuetablePagination } from '@/@types/vuetable.d';
import VuetableMixin from '@/mixins/vuetable';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import DatatableHeading from '@/components/piaf/Datatable/DatatableHeading.vue';
import VuetablePaginationBootstrap from '@/components/piaf/Common/VuetablePaginationBootstrap.vue';
import {
  getBannerList,
  deleteBannerItem,
  putSortList,
  postActiveStatus,
} from '@/configs/api-path';
import { AdminRoleList } from '@/configs/role';
import { roleIsHigherThen } from '@/utils/role';
import { BannerListItem } from '@/models/banner';
import { UserLogin } from '@/models/user';

@Component({
  components: {
    DatatableHeading,
    VuetablePaginationBootstrap,
  },
})
export default class PageBannerList extends mixins(
  VuetableMixin, ApiStatusMixin, ApiErrorMixin,
) {
  tablePrepage = 10;

  bannerList: BannerListItem[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataTableFields: any[] = [
    {
      name: 'thumbnail--slot',
      title: '縮圖',
      dataClass: 'custom-img p-0 position-relative',
      width: '160px',
    },
    // {
    //   name: 'id',
    //   title: '#',
    //   width: '80px',
    // },
    {
      name: 'web_photo_name',
      title: '圖片名稱',
      sortField: this.sortMode ? null : 'web_photo_name',
    },
    // {
    //   name: 'sort',
    //   title: '排序',
    //   width: '78px',
    //   sortField: this.sortMode ? null : 'sort',
    //   titleClass: 'text-center',
    //   dataClass: 'text-center',
    // },
    {
      name: 'status--slot',
      title: '狀態',
      width: '110px',
      titleClass: 'text-center',
      dataClass: 'text-center',
      sortField: this.sortMode ? null : 'status',
    },
    {
      name: 'action--slot',
      title: '操作',
      width: '198px',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
  ];

  get filtedBannerList() {
    return this.bannerList
      .filter((banner) => {
        const matchRegexp = new RegExp(this.filterKeyword === '' ? '.*' : `.*(${this.filterKeyword}).*`, 'gi');

        const matchWebPhotoName = banner.web_photo_name.match(matchRegexp);
        const matchWebPhotoPath = banner.web_photo_path.match(matchRegexp);

        return Boolean(matchWebPhotoName)
          || Boolean(matchWebPhotoPath);
      });
  }

  get canSort() {
    return this.bannerList.length > 1;
  }

  // eslint-disable-next-line class-methods-use-this
  get breadcrumb() {
    return [
      {
        text: '首頁管理',
        to: null,
      },
      {
        text: '輪播管理',
        to: null,
      },
      // {
      //   text: '輪播列表',
      //   to: null,
      // },
    ];
  }

  @Getter('user/currentUser') currentUser!: UserLogin;

  @Watch('filtedBannerList')
  onFiltedBannerListChange() {
    this.$refs.vuetable.refresh();
  }

  @Watch('tablePrepage')
  onTablePrepageChange() {
    if (this.vuetablePrepage !== undefined) {
      this.vuetablePrepage = this.tablePrepage;
    }
    this.$refs.vuetable.refresh();
  }

  @Watch('sortMode')
  onSortModeChange(newValue: boolean) {
    this.$refs.vuetable.refresh();

    if (newValue === false) {
      this.fetchBannerList();
    }
  }

  testRoleIsHigher(roleCode: number) {
    return roleIsHigherThen((this.currentUser.role as AdminRoleList).code, roleCode, true);
  }

  changePageSize(size: number) {
    this.tablePrepage = size;
  }

  onChangePage(page: number) {
    this.$refs.vuetable.changePage(page);
  }

  toggleSortMode() {
    this.sortMode = !this.sortMode;
  }

  getIndexInRealList(bannerId: number) {
    const sortedBannerList = this.bannerList;

    const indexInList = sortedBannerList.findIndex((banner) => banner.id === bannerId);

    return {
      isFirst: indexInList === 0,
      isLast: indexInList === sortedBannerList.length - 1,
      index: indexInList,
    };
  }

  dataManager(sortOrder: VuetableSortOrder[], pagination: VuetablePagination) {
    const tableData = this.vuetableDataManager(
      this.sortMode ? [] : sortOrder,
      pagination,
      this.$refs.vuetable,
      this.sortMode ? this.bannerList : this.filtedBannerList,
    );
    this.tablePagination = tableData.pagination;
    return tableData;
  }

  onPaginationData(paginationData: VuetablePagination) {
    this.$refs.pagination.setPaginationData(paginationData);
  }

  async sortBanner(bannerId: number, direction: 1 | -1) {
    const currentPosition = this.getIndexInRealList(bannerId);
    // check sort request is avaliable
    if (
      (currentPosition.isFirst === true && direction === -1)
      || (currentPosition.isLast === true && direction === 1)
    ) {
      console.warn('You cannot do this action.');
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sotrList = (list: any[], fromId: number, mutate = false) => {
      const currentList = list;
      const targetIndex = currentList.findIndex((item) => item.id === fromId);
      const nextIndex = targetIndex + direction;

      if (mutate === true) {
        arrayMove.mutate(currentList, targetIndex, nextIndex);
      }

      return arrayMove(clone(currentList), targetIndex, nextIndex);
    };

    try {
      const newOrderIds: number[] = sotrList(this.bannerList, bannerId)
        .map((banner) => banner.id);

      this.setApiLoading();
      const { data: sortItemResponse } = await this.$axios.put<{
        code: number;
      }>(putSortList, {
        page: 1,
        object_ids: newOrderIds,
      });
      this.setApiPending();

      if (sortItemResponse.code === 0) {
        this.fetchBannerList();
        return;
      }

      this.apiErrorCodeAlert(sortItemResponse.code, '輪播排序');
    } catch (error) {
      console.error(error);
      this.setApiPending();
      this.$notify.show('error filled', '儲存輪播排序時發生錯誤。', '輪播排序', {
        duration: 3000,
        permanent: false,
      });
    }
  }

  async toggleBannerStatus(nextStatus: boolean, banner: BannerListItem) {
    if (!banner.id) {
      return;
    }

    this.setApiLoading();
    try {
      const statusData = {
        module: 3,
        targetId: banner.id,
        status: nextStatus,
      };

      const { data: bannerStatusResponse } = await this.$axios.post<{
        code: number;
      }>(postActiveStatus, statusData);

      if (bannerStatusResponse.code === 0) {
        this.$notify.show('success filled', `輪播 #${banner.id} 已${nextStatus === true ? '啟用' : '停用'}！`, `${nextStatus === true ? '啟用' : '停用'}輪播`, { duration: 3000, permanent: false });
      } else {
        const bannerInList = this.bannerList.find((oBanner) => oBanner.id === banner.id);
        if (bannerInList) {
          bannerInList.status = !nextStatus;
        }
        this.apiErrorCodeAlert(bannerStatusResponse.code, `${nextStatus === true ? '啟用' : '停用'}輪播`);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async fetchBannerList() {
    this.setApiLoading();
    try {
      const { data: bannerListResponse } = await this.$axios.get<{
        code: number;
        banner: BannerListItem[];
      }>(getBannerList);

      if (bannerListResponse.code === 0) {
        this.bannerList = bannerListResponse.banner.map((banner, index) => ({
          ...banner,
          sort: index,
        }));
      } else {
        this.apiErrorCodeAlert(bannerListResponse.code);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async deleteBanner(banner: BannerListItem) {
    if (!banner.id) {
      return;
    }

    const bannerId = banner.id as number;
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(`確定刪除 #${banner.id} 輪播？\n刪除後將無法復原該組輪播。`);

    if (confirm === false) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: bannerItemResponse } = await this.$axios.delete<{
        code: number;
        banner: {
          id: number;
        };
      }>(deleteBannerItem(bannerId));

      if (bannerItemResponse.code === 0) {
        this.$notify.show('success filled', `輪播 #${banner.id} 已刪除！`, '刪除輪播', { duration: 3000, permanent: false });

        const bannerIndexInList = this.bannerList.findIndex((oBanner) => oBanner.id === bannerId);

        this.bannerList.splice(bannerIndexInList, 1);
      } else {
        this.apiErrorCodeAlert(bannerItemResponse.code, '刪除輪播');
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  beforeMount() {
    this.fetchBannerList();
  }
}
